import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';

const OurTeam = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { labelKey: 'nav.aboutUs', href: '/#about-us' },
    { labelKey: 'aboutUs.ourTeam' }
  ];

  return (
    <PageTemplate 
      titleKey="pages.ourTeam.title"
      subtitleKey="pages.ourTeam.subtitle"
      breadcrumbs={breadcrumbs}
    >
      <div className="content-card">
        <h2>{t('pages.ourTeam.intro.title')}</h2>
        <p>{t('pages.ourTeam.intro.description')}</p>

        <h3>{t('pages.ourTeam.leadership.title')}</h3>
        <p>{t('pages.ourTeam.leadership.description')}</p>

        <div className="team-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '30px', margin: '40px 0' }}>
          <div className="team-member" style={{ textAlign: 'center', padding: '30px', background: '#f8f9fa', borderRadius: '12px' }}>
            <div style={{ width: '120px', height: '120px', borderRadius: '50%', background: '#667eea', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '36px', fontWeight: '700' }}>
              CEO
            </div>
            <h4 style={{ fontSize: '20px', marginBottom: '5px', color: '#2c3e50' }}>{t('pages.ourTeam.members.ceo.name')}</h4>
            <p style={{ color: '#667eea', marginBottom: '15px', fontWeight: '600' }}>{t('pages.ourTeam.members.ceo.title')}</p>
            <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6' }}>{t('pages.ourTeam.members.ceo.bio')}</p>
          </div>

          <div className="team-member" style={{ textAlign: 'center', padding: '30px', background: '#f8f9fa', borderRadius: '12px' }}>
            <div style={{ width: '120px', height: '120px', borderRadius: '50%', background: '#667eea', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '36px', fontWeight: '700' }}>
              COO
            </div>
            <h4 style={{ fontSize: '20px', marginBottom: '5px', color: '#2c3e50' }}>{t('pages.ourTeam.members.coo.name')}</h4>
            <p style={{ color: '#667eea', marginBottom: '15px', fontWeight: '600' }}>{t('pages.ourTeam.members.coo.title')}</p>
            <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6' }}>{t('pages.ourTeam.members.coo.bio')}</p>
          </div>

          <div className="team-member" style={{ textAlign: 'center', padding: '30px', background: '#f8f9fa', borderRadius: '12px' }}>
            <div style={{ width: '120px', height: '120px', borderRadius: '50%', background: '#667eea', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '36px', fontWeight: '700' }}>
              CFO
            </div>
            <h4 style={{ fontSize: '20px', marginBottom: '5px', color: '#2c3e50' }}>{t('pages.ourTeam.members.cfo.name')}</h4>
            <p style={{ color: '#667eea', marginBottom: '15px', fontWeight: '600' }}>{t('pages.ourTeam.members.cfo.title')}</p>
            <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6' }}>{t('pages.ourTeam.members.cfo.bio')}</p>
          </div>
        </div>

        <h3>{t('pages.ourTeam.departments.title')}</h3>
        <ul className="icon-list">
          <li><strong>{t('pages.ourTeam.departments.consulting.title')}</strong> - {t('pages.ourTeam.departments.consulting.desc')}</li>
          <li><strong>{t('pages.ourTeam.departments.research.title')}</strong> - {t('pages.ourTeam.departments.research.desc')}</li>
          <li><strong>{t('pages.ourTeam.departments.legal.title')}</strong> - {t('pages.ourTeam.departments.legal.desc')}</li>
          <li><strong>{t('pages.ourTeam.departments.operations.title')}</strong> - {t('pages.ourTeam.departments.operations.desc')}</li>
        </ul>

        <div className="feature-box">
          <h4>{t('pages.ourTeam.joinUs.title')}</h4>
          <p>{t('pages.ourTeam.joinUs.description')}</p>
          <a href="/connect-us" className="page-action-button" style={{ marginTop: '15px' }}>
            {t('pages.ourTeam.joinUs.button')}
          </a>
        </div>
      </div>
    </PageTemplate>
  );
};

export default OurTeam;
